import { CommonModule, NgFor, NgStyle } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCard } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { BreadcrumbsComponent } from '../breadcrumbs/breadcrumbs.component';
import { DropdownModule } from 'primeng/dropdown';
import { MatButtonModule } from '@angular/material/button';
import { PopupType } from '../../app-popup/app-popup.component';
import { IraAlertPopupComponent } from '../../ira-alert-popup/ira-alert-popup.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SharedService } from '../../../services/shared.service';
import { LoadingService } from '../../../services/loading.service';
import { MatTooltip } from '@angular/material/tooltip';
import {
  DomSanitizer,
  SafeResourceUrl,
  SafeUrl,
} from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NotificationService } from '../../notification/notification.service';
import { NotificationPopupComponent } from '../../notification-popup/notification-popup.component';
import { AccessDeniedPopupComponent } from '../../access-denied-popup/access-denied-popup.component';
import { WebSocketService } from '../../../services/websocket.service';
import { filter, Subscription } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { AppclosenotificationDirective } from '../../../directives/appclosenotification.directive';
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    FormsModule,
    MatIcon,
    ReactiveFormsModule,
    CommonModule,
    MatMenuModule,
    MatListModule,
    BreadcrumbsComponent,
    NgStyle,
    NgFor,
    DropdownModule,
    MatButtonModule,
    MatTooltip,
    RouterModule,
    MatIcon,
    AppclosenotificationDirective,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  @Input() isRowVisible: boolean = false;
  @Input() pageSource: any;
  @Input() routeSource: any;
  @Input() pathFrom: any;
  @Input() isReloaded: boolean = false;
  // to clear the selected product
  isLoadButtonClicked = false;
  isSelectionReset = false;
  @Output() clearResultsData = new EventEmitter<void>();
  @Output() loadData = new EventEmitter<any>();
  @Input() showBreadcrumbs: boolean = true;
  // @Input() routeName: any;
  @Input() pageData: any; // Initialize with an empty array to avoid undefined errors
  projectValue: any;
  productValue: any;
  geographyValue: any;
  languageValue: any;
  productsData: any;
  geographyData: any;
  selectedProject: any;
  selectedProduct: any;
  selectedGeography: any;
  raiseIncident: SafeResourceUrl;
  claimSupport: SafeResourceUrl;
  faq: SafeResourceUrl;
  rdUrl: SafeResourceUrl;
  hasNew = false;
  panelVisible = false;
  notifications: any[] = [];
  messages: any[] = [];
  loggedInUser: any;
  savedNotificationDetails: any = [];
  notificationDetails: any = [];
  private messageSubscription: Subscription;
  projectLink: any;
  projectId: any;
  productLink: any;
  productId: any;
  urlDomain: any;

  constructor(
    public sharedService: SharedService,
    private dialog: MatDialog,
    public loadingService: LoadingService,
    private sanitizer: DomSanitizer,
    private notificationService: NotificationService,
    private authService: MsalService,
    private webSocketService: WebSocketService,
    private cdr: ChangeDetectorRef
  ) {
    const raiseIncidentUrl =
      'https://unilever.service-now.com/esc?id=sc_cat_item&table=sc_cat_item&sys_id=6732e9e11bfeb05491084337b04bcb95';
    const claimSupportUrl =
      'https://engage.cloud.microsoft/main/org/unilever.com/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIyMTU1NDAwMzE0ODgifQ';
    //const faqUrl =
    // 'https://unilever.sharepoint.com/sites/BetterBolderFasterClaims/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FBetterBolderFasterClaims%2FShared%20Documents%2FTraining%20Materials%2FNew%20Training%20Content&viewid=704fc292%2D4157%2D4007%2D9c69%2D06f90a1bd196&csf=1&web=1&e=K64RK6&FolderCTID=0x012000441D8AC6A3ADD64D8DC504362036C398';
    const faqUrl =
      'https://unilever.sharepoint.com/sites/BetterBolderFasterClaims/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FBetterBolderFasterClaims%2FShared%20Documents%2FTraining%20Materials%2FNew%20Training%20Content&viewid=704fc292%2D4157%2D4007%2D9c69%2D06f90a1bd196&csf=1&web=1&e=K64RK6&FolderCTID=0x012000441D8AC6A3ADD64D8DC504362036C398';

    const rdUrl = 'https://research-assistant.unilever.com/';

    // this.raiseIncident =
    //   this.sanitizer.bypassSecurityTrustResourceUrl(raiseIncidentUrl);
    // this.claimSupport =
    //   this.sanitizer.bypassSecurityTrustResourceUrl(claimSupportUrl);
    // this.faq = this.sanitizer.bypassSecurityTrustResourceUrl(faqUrl);
    // this.rdUrl = this.sanitizer.bypassSecurityTrustResourceUrl(rdUrl);

    this.raiseIncident = raiseIncidentUrl;
    this.claimSupport = claimSupportUrl;
    this.faq = faqUrl;
    this.rdUrl = rdUrl;
  }

  ngOnInit() {
    this.openNotifications();
    this.showBreadcrumbs = true;
    this.urlDomain = localStorage.getItem('urlDomain');
    this.projectId = localStorage.getItem('project');
    this.productId = localStorage.getItem('product');
    this.projectLink =
      'https://' +
      this.urlDomain +
      '/ui/#t/0TB000000000733/V2C/' +
      this.projectId;
    this.productLink =
      'https://' +
      this.urlDomain +
      '/ui/#t/0TB00000000R001/V18/' +
      this.productId;
    console.log('t4st page');
    console.log('page source', this.pageSource);
    this.projectValue = localStorage.getItem('projectName');
    this.productValue = localStorage.getItem('productName');
    this.geographyValue = localStorage.getItem('geographyName')
      ? localStorage.getItem('geographyName')
      : localStorage.getItem('geographyNamepopup');

    this.languageValue = localStorage.getItem('language');

    this.loggedInUser = sessionStorage.getItem('loggedInUser');
    this.selectedProduct = localStorage.getItem('product');

    this.selectedGeography = localStorage.getItem('geography');

    this.lastConfirmedProduct = this.selectedProduct;
    this.lastConfirmedGeography = this.selectedGeography;

    if (this.selectedProduct || this.selectedGeography) {
      console.log('selectedProduct', this.selectedProduct);
      console.log('selectedGeography', this.selectedGeography);
      //this.isLoadButtonClicked = true;
      //this.loadData.emit(true);

      this.isLoadButtonClicked = true;

      setTimeout(() => {
        if (this.routeSource == 'Draft') {
          this.loadData.emit('success');
        } else {
          this.loadData.emit(true);
        }
      }, 1000);
    }

    // setTimeout(() => {
    //   if (this.selectedProduct || this.selectedGeography) {
    //     this.loadData.emit(true);
    //   }
    // }, 1000);

    // this.notificationService
    //   .hasNewNotifications()
    //   .subscribe((flag) => (this.hasNew = flag));

    // this.webSocketService.socketConnection();

    // this.webSocketService.onResultDataSaved().subscribe((data) => {
    //   console.log('Socket message:', data);
    // this.notifications = [data.response_notifications];
    // console.log('notification', this.notifications);
    // this.hasNew = data.length > 0;
    // });

    // this.webSocketService.saveVeeva$.subscribe((data) => {
    //   console.log('Received save_veeva:', data);
    // });

    // this.webSocketService.saveVeeva$.subscribe((data) => {
    //   console.log('Received save_veeva:', data);
    // });

    // this.webSocketService.socketEvents$
    //   .pipe(filter((e) => e.event === 'save_veeva'))
    //   .subscribe(({ data }) => {
    //     console.log('Socket message:', data);
    //     this.notifications = [data.response_notifications];
    //     // console.log('notification', this.notifications);
    //     this.hasNew = data.length > 0;
    //     // Your logic here
    //   });

    // this.webSocketService.onDataError().subscribe((error) => {
    //   console.error('Socket error:', error);
    // });

    // const payload = {
    //   user_id: localStorage.getItem('userId'),
    // };

    //to get saved notifications
    // const notificationData: any = [];
    // this.notificationService
    //   .getSavedNotifications(payload)
    //   .subscribe((response: any) => {
    //     response.data.forEach((element: any) => {
    //       notificationData.push(element);
    //     });

    //     notificationData.map((response) => {
    //       console.log('res', response);

    //       const result = response.notification.result || {};

    //       // Sum all numeric values in the result object
    //       const total = Object.values(result).reduce(
    //         (sum: any, val: any) => sum + (typeof val === 'number' ? val : 0),
    //         0
    //       );

    //       const created = result.SUCCESS ?? 0;
    //       const updated = result.WARNING ?? 0;
    //       const failed = result.FAILURE ?? 0;

    //       response.total = total;
    //       response.type = response.type || 'claims';

    //       response.summary = `${total} ${response.type} Submitted Successfully. Including ${created} Created, ${updated} Updated, ${failed} Failed.`;
    //       this.savedNotificationDetails.push(response);
    //       return response;
    //     });
    // console.log('transformedNotifications', transformedNotifications);
    // });

    console.log('getSavedNotifications', this.savedNotificationDetails);

    const relevantEvents = ['save_veeva', 'save_edit_la', 'save_ira_veeva'];

    // Socket logic commented

    this.webSocketService.socketEvents$
      .pipe(filter((e) => relevantEvents.includes(e.event)))
      .subscribe((message) => {
        console.log(message);
      });

    // this.notificationService.getNotifications().subscribe((newData) => {
    //   const current =
    //     this.notificationService.savedNotificationsSubject.getValue();

    //   // Filter out duplicates based on a unique key (e.g., summary + timestamp)
    //   const uniqueNewData = newData.filter((newItem) => {
    //     return !current.some(
    //       (existingItem) => existingItem.summary === newItem.summary
    //     );
    //   });

    //   const combined = [...uniqueNewData, ...current];

    //   console.log('combined', combined);
    //   this.notificationService.savedNotificationsSubject.next(combined);
    // });

    this.notificationService.savedNotifications$.subscribe((data) => {
      console.log('data', data);
      // this.notifications = data;
      this.hasNew = data.length > 0;
    });

    // Load saved notifications once
    // this.notificationService.getSavedNotifications(payload);

    if (this.pageSource == 'Editclaims') {
      console.log('route EditClaimsFlow', this.pageSource);

      console.log('path from', this.pathFrom);
      // if (this.pathFrom != 'home-editclaims') {
      //   console.log('home ', this.pathFrom);
      //   this.selectedProduct = null;
      //   this.selectedGeography = null;
      //   localStorage.removeItem('product');
      //   localStorage.removeItem('geography');
      //   localStorage.removeItem('productName');
      //   localStorage.removeItem('geographyName');
      // }

      // localStorage.removeItem('product');
      // localStorage.removeItem('routeFrom');

      // localStorage.removeItem('geographyNamepopup');
      console.log('eidtclaims');
      this.getMetadata();
      // this.getSessionId();
    }
    // this.loadTableData();
  }

  togglePanel(): void {
    console.log('panelVisible', this.panelVisible);
    console.log('hasNew', this.hasNew);
    this.panelVisible = !this.panelVisible;
    // if (this.panelVisible) {
    this.notificationService.markAsRead();
    this.hasNew = false;
    // }
  }

  openNotifications() {
    const payload = {
      user_id: localStorage.getItem('userId'),
    };

    //to get saved notifications
    // const notificationData: any = [];
    // this.notificationService
    //   .getSavedNotifications(payload)
    //   .subscribe((response: any) => {
    //     console.log('response', response);
    //     this.notifications = response.data;
    //   });
    //to get saved notifications
    const notificationData: any = [];
    this.notificationService
      .getSavedNotifications(payload)
      .subscribe((notificationResponse: any) => {
        console.log('notification response', notificationResponse);
        notificationResponse.data.forEach((element: any) => {
          notificationData.push(element);
        });

        const notificationDataValues = notificationData.map((response) => {
          console.log('res', response);
          const projectId = response.notification.project_id;
          const projectValue = response.notification.projectName;
          console.log('this.projectValue', projectValue);
          const productId = response.notification.product_id;
          const productValue = response.notification.productName;
          const projectLink = `${projectValue.slice(0, 20)}...`;

          const productLink = `${productValue.slice(0, 20)}...`;
          const result = response.notification.result || {};

          // Sum all numeric values in the result object
          const total = response.notification.total;
          const type =
            response.notification.type == 'la' ? 'local adaptations' : 'claims';
          const created = result.SUCCESS ?? 0;
          const updated = result.WARNING ?? 0;
          const failed = result.FAILURE ?? 0;
          const deleted = response?.notification.deletedCount ?? 0;

          // response.total = total;
          // response.type = response.type;
          response.timestamp = response.notification.timestamp;
          // response.summary = `${total} ${type} Submitted Successfully. Including ${created} Created, ${updated} Updated, ${failed} Failed.`;
          response.summary =
            total +
            ' ' +
            type +
            ' Submitted for ' +
            projectLink +
            ' and ' +
            productLink +
            '. Including ' +
            created +
            ' Created, ' +
            updated +
            ' Updated, ' +
            deleted +
            ' Deleted, ' +
            failed +
            ' Failed.';
          this.savedNotificationDetails.push(response);
          return response;
        });

        console.log('notificationDataValues', notificationDataValues);
        this.notifications = this.normalizeNotification(notificationDataValues);
        console.log('notifications', this.notifications);

        this.hasNew = this.notifications.some((data) => {
          return data.view_status == 'NO';
        });
        console.log('hasnew', this.hasNew);
      });
  }

  markAsRead(originalResponse) {
    console.log('originalResponse', originalResponse);
    const payload = {
      user_id: localStorage.getItem('userId'),
      project_id: originalResponse.notification.project_id,
      product_id: originalResponse.notification.product_id,
      notification_id: originalResponse.notification_id,
    };
    this.notificationService
      .getUpdateNotificationViewStatus(payload)
      .subscribe((response) => {
        console.log('response', response);
        // fetch latest notifications
        this.notificationService
          .getSavedNotifications({ user_id: localStorage.getItem('userId') })
          .subscribe((notificationResponse: any) => {
            // Update the local notification immediately
            const notificationIndex = this.notifications.findIndex(
              (notification) =>
                notification.notification_id ===
                originalResponse.notification_id
            );

            if (notificationIndex !== -1) {
              this.notifications[notificationIndex].view_status = 'YES';

              //  Update hasNew flag based on remaining unread notifications
              this.hasNew = this.notifications.some(
                (notification) => notification.view_status === 'NO'
              );

              //  Trigger change detection
              this.cdr.detectChanges();
            }
          });
      });
  }
  isNotificationPopupOpen = false;
  openDetails(originalResponse: any): void {
    this.markAsRead(originalResponse);
    // Wrap it into the desired structure
    // const geography = localStorage.getItem('geographyName');
    // const transformedResponse = {
    //   save_response: {
    //     geography: originalResponse,
    //   },
    // };

    // //  to convert response object to array
    // const result = Object.entries(transformedResponse.save_response).reduce(
    //   (acc: any, curr) => {
    //     const [key, val]: any = curr;
    //     acc.push({ GEOGRAPHY: key, ...val });
    //     return acc;
    //   },
    //   []
    // );
    // this.webSocketService.sendMessage(result);
    this.isNotificationPopupOpen = true;
    const dialogRef = this.dialog.open(NotificationPopupComponent, {
      data: originalResponse.notification,
      width: '1000px',
    });
    dialogRef.afterClosed().subscribe(() => {
      this.isNotificationPopupOpen = false;
    });
  }
  @ViewChild('menuTrigger') menuTrigger: MatMenuTrigger;
  onNotificationClickOutside() {
    if (!this.isNotificationPopupOpen) {
      this.menuTrigger.closeMenu();
    }
  }

  //to format the notification response
  normalizeNotification(items: any[]): any[] {
    return items.map((item) => {
      const notification = { ...item.notification };
      const summary = item.summary;
      const timestamp = item.timestamp;
      if (
        notification.save_response &&
        typeof notification.save_response === 'object'
      ) {
        const countryKeys = Object.keys(notification.save_response);

        if (countryKeys.length > 0) {
          const geography = countryKeys[0];
          const countryData = notification.save_response[geography];

          if (countryData && typeof countryData === 'object') {
            for (const [key, value] of Object.entries(countryData)) {
              notification[key] = value;
            }

            notification['Geography'] = geography;
          }
        }

        delete notification.save_response;
        delete notification.delete_response;
      } else {
        notification['Geography'] = '';
      }

      return {
        notification,
        summary,
        timestamp,
        view_status: item.view_status,
        notification_id: item.notification_id,
      };
    });
  }

  getSessionId() {
    const sessionId =
      '98D4F83E2AE19550C64F687042A5B7B83DD0418A8416FB5A0CFFBBCD7EA5259D68DA46EB73C405E033C8DE0D7F98E1BA3ADF58E72C37F530F210C6B27213F238';
    sessionStorage.setItem('sessionId', sessionId);
  }

  //get metadata information
  async getMetadata() {
    console.log('test metadaata 2');
    this.loadingService.setLoading(true);
    setTimeout(() => {
      const data = {
        session_id: sessionStorage.getItem('sessionId'),
        project_id: localStorage.getItem('projectId'),
        application: 'EEOC',
        environment: localStorage.getItem('environment'),
        doc_id: '-',
      };

      this.sharedService.getMetaData(data).subscribe((response: any) => {
        console.log('test metadaata 5');
        response.forEach((element) => {
          if (element.errors) {
            console.log('test metadaata 3');
            const dialogConfig = new MatDialogConfig();
            dialogConfig.data = {
              message: element.errors,
              icon: './assets/img/icons/user-icon.svg',
              buttons: [{ id: 'OK', text: 'OK' }],
              submitButtonId: 'OK',
              type: PopupType.ERROR,
            } as any;
            dialogConfig.disableClose = true;
            this.dialog
              .open(IraAlertPopupComponent, dialogConfig)
              .afterClosed()
              .subscribe();
          } else {
            if (element.project.length == 1) {
              this.selectedProject = element.project[0].project_id;
              localStorage.setItem('project', element.project[0].project_id);
              this.projectValue = element.project[0].project_name;
              localStorage.setItem(
                'projectName',
                element.project[0].project_name
              );
              console.log('test metadaata 1');
              this.getDetailsFromProject(response, this.selectedProject);
            } else {
              this.selectedProject = '';
            }
          }
        });
        this.loadingService.setLoading(false);
      });
    }, 100);
  }

  // to get initial information of geography data and project
  getDetailsFromProject(data, projectId) {
    //to get product based on project
    this.productsData = data[0].product.filter((value) => {
      return value.project__v === projectId;
    });
    console.log(' this.productsData ', this.productsData);
    // to get geography details based on project
    this.geographyData = data[0].geography.filter((value) => {
      return value.project__v === projectId;
    });
    console.log(' this.geographyData ', this.geographyData);
    //to get project access details
    const projAccess = data[0]?.project_access.filter((value) => {
      return value.project_id === this.selectedProject;
    });
    const projectAccessDetails = projAccess[0]?.isProjectLinked;
    localStorage.setItem('projectAccess', JSON.stringify(projectAccessDetails));
    localStorage.setItem('userRole', data[0].user_security_profile);
    localStorage.setItem('userId', data[0].user_id);
    // this.projectAccessData.emit(this.projectAccessDetails);

    //to get role access details
    const roleAccess = data[0]?.project_access.filter((value) => {
      return value.project_id === this.selectedProject;
    });
    const isRoleAccess = roleAccess[0]?.isAccess;
    localStorage.setItem('roleAccess', JSON.stringify(isRoleAccess));
    localStorage.setItem(
      'projectAccessDetails',
      JSON.stringify(data[0]?.project_access)
    );
  }

  // getDetailsFromProject(data, projectId) {
  //   // Filter products and geographies based on project
  //   this.productsData = data[0].product.filter(
  //     (value) => value.project__v === projectId
  //   );
  //   this.geographyData = data[0].geography.filter(
  //     (value) => value.project__v === projectId
  //   );

  //   // Set selected product and geography from localStorage
  //   const storedProduct = localStorage.getItem('product');
  //   const storedGeography = localStorage.getItem('geography');

  //   if (storedProduct) {
  //     this.selectedProduct = storedProduct;
  //     this.lastConfirmedProduct = storedProduct;
  //   }

  //   if (storedGeography) {
  //     this.selectedGeography = storedGeography;
  //     this.lastConfirmedGeography = storedGeography;
  //   }

  //   // Set other access details
  //   const projAccess = data[0]?.project_access.filter(
  //     (value) => value.project_id === this.selectedProject
  //   );
  //   const projectAccessDetails = projAccess[0]?.isProjectLinked;
  //   localStorage.setItem('projectAccess', JSON.stringify(projectAccessDetails));
  //   localStorage.setItem('userRole', data[0].user_security_profile);
  //   localStorage.setItem('userId', data[0].user_id);

  //   const roleAccess = data[0]?.project_access.filter(
  //     (value) => value.project_id === this.selectedProject
  //   );
  //   const isRoleAccess = roleAccess[0]?.isAccess;
  //   localStorage.setItem('roleAccess', JSON.stringify(isRoleAccess));
  //   localStorage.setItem(
  //     'projectAccessDetails',
  //     JSON.stringify(data[0]?.project_access)
  //   );
  // }

  get selectedProductTitle(): string {
    if (!Array.isArray(this.productsData)) {
      return '';
    }

    const selected = this.productsData.find(
      (product) => product.product__v === this.selectedProduct
    );
    return selected?.product_title || '';
  }
  get selectedGeographyName(): string {
    if (!Array.isArray(this.geographyData)) {
      return '';
    }

    const selected = this.geographyData.find(
      (geo) => geo.country__v === this.selectedGeography
    );
    return selected?.country_name || '';
  }

  logout() {
    // to show access denied popup when user trying Sparci URL directly

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    (dialogConfig.height = '260px'),
      (dialogConfig.width = '345px'),
      (dialogConfig.data = {
        icon: '../../../assets/images/icons/access-denied.png',
        height: '75',
        method: 'logout',
        //   message:'You will be logging out of SPARCi and this window will be closed',
        type: PopupType.ERROR,
      } as any);
    this.dialog
      .open(AccessDeniedPopupComponent, dialogConfig)
      .afterClosed()
      .subscribe((response) => {});
    sessionStorage.clear();
    setTimeout(() => {
      this.authService.logoutRedirect();
    }, 10000);
  }

  // getSelectedProduct(event) {
  //   console.log('event', event);
  //   this.selectedProduct = event.value;
  //   localStorage.setItem('product', this.selectedProduct);

  //   const productData = this.productsData.filter((value) => {
  //     return value.product__v == this.selectedProduct;
  //   });

  //   const businessGroup = productData[0].business_group;
  //   if (businessGroup != '') {
  //     localStorage.setItem('businessGroup', businessGroup);
  //   }

  //   const category = productData[0].category;
  //   if (category != '') {
  //     localStorage.setItem('category', category);
  //   }
  // }
  // getSelectedGeography(event) {
  //   console.log('event', event);
  //   console.log('this.selectedGeography ', this.selectedGeography);
  //   this.selectedGeography = event.value;
  //   localStorage.setItem('geography', this.selectedGeography);
  // }
  lastConfirmedProduct: any = null;
  lastConfirmedGeography: any = null;

  getSelectedProduct(event) {
    const newProduct = event.value;
    console.log('newProduct', newProduct);
    console.log('event', event);

    // Get the product title from productsData
    const selectedProductData = this.productsData.find(
      (product) => product.product__v === newProduct
    );
    const productTitle = selectedProductData?.product_title || '';

    console.log('newProduct', newProduct);
    console.log('productTitle', productTitle);
    console.log('event', event);
    // localStorage.setItem('productName', productTitle);
    console.log('this.isLoadButtonClicked', this.isLoadButtonClicked);
    console.log('this.isFreshSelection()', this.isFreshSelection());
    console.log('this.lastConfirmedProduct', this.lastConfirmedProduct);
    console.log('newProduct', newProduct);
    if (
      this.isLoadButtonClicked &&
      !this.isFreshSelection() &&
      this.lastConfirmedProduct !== newProduct
    ) {
      const dialogRef = this.dialog.open(IraAlertPopupComponent, {
        width: '370px',
        height: '190px',
        disableClose: true,
        data: {
          messages: 'Any changes to product will reload the page. All unsaved',
          messagessub: 'changes will be lost. Do you wish to proceed?',
          messageType: 'clearProduct',
        },
      });

      dialogRef.afterClosed().subscribe((confirm) => {
        if (confirm === true) {
          // User confirmed change
          this.selectedProduct = newProduct;
          this.lastConfirmedProduct = newProduct;
          this.updateProductDetails(newProduct, productTitle);
          this.loadData.emit(true); // reload table

          // Emit variable only for Editclaims
          console.log('this.pageSource', this.pageSource);
          //  //console.log('roteFrom',this.routeFrom)
          // if (this.pageSource === 'editClaims') {
          //   this.loadData.emit({ editClaimsLoaded: true });
          // }
        } else {
          // User cancelled change
          this.selectedProduct = this.lastConfirmedProduct;
        }
      });
    } else {
      // Initial selection or before load
      this.selectedProduct = newProduct;
      //this.lastConfirmedProduct = newProduct;
      this.updateProductDetails(newProduct, productTitle);
    }
  }

  updateProductDetails(productValue: any, productTitle: any) {
    localStorage.setItem('product', productValue);
    localStorage.setItem('productName', productTitle);
    const productData = this.productsData.find(
      (value) => value.product__v === productValue
    );

    if (productData) {
      const { business_group, category } = productData;

      if (business_group) {
        localStorage.setItem('businessGroup', business_group);
      }

      if (category) {
        localStorage.setItem('category', category);
      }
    }
  }

  getSelectedGeography(event) {
    const newGeography = event.value;
    console.log('newGeography', newGeography);

    // Get the geography name from geographyData
    const selectedGeographyData = this.geographyData.find(
      (geo) => geo.country__v === newGeography
    );
    const geographyName = selectedGeographyData?.country_name || '';

    console.log('newGeography', newGeography);
    console.log('geographyName', geographyName);
    console.log('event', event);

    if (
      this.isLoadButtonClicked &&
      !this.isFreshSelection() &&
      this.lastConfirmedGeography !== newGeography
    ) {
      const dialogRef = this.dialog.open(IraAlertPopupComponent, {
        width: '370px',
        height: '190px',
        disableClose: true,
        data: {
          messages:
            'Any changes to geography will reload the page. All unsaved',
          messagessub: 'changes will be lost. Do you wish to proceed?',
          messageType: 'clearProduct',
        },
      });

      // dialogRef.afterClosed().subscribe((confirm) => {
      //   if (confirm === true) {
      //     // User confirmed change
      //   data: {
      //     messages:"",
      //     messagessub:'',
      //     messageType: 'clearProduct',
      //   },
      // });

      dialogRef.afterClosed().subscribe((confirm) => {
        if (confirm === true) {
          // User confirmed change
          this.selectedGeography = newGeography;
          this.lastConfirmedGeography = newGeography;
          this.updateGeographyDetails(newGeography, geographyName);
          this.loadData.emit(true); // reload table
          console.log('testing load ');
        } else {
          // User cancelled change
          this.selectedGeography = this.lastConfirmedGeography;
        }
      });
    } else {
      // Initial selection or before load
      this.selectedGeography = newGeography;
      this.lastConfirmedGeography = newGeography;
      this.updateGeographyDetails(newGeography, geographyName);
    }
  }

  updateGeographyDetails(geographyValue: any, geographyName: any) {
    localStorage.setItem('geography', geographyValue);
    localStorage.setItem('geographyName', geographyName);
  }

  //to load edit claims table data
  loadTableData() {
    this.isLoadButtonClicked = true;

    // Confirm current selections
    this.lastConfirmedProduct = this.selectedProduct;
    this.lastConfirmedGeography = this.selectedGeography;

    this.loadData.emit(true);
  }

  clearSelectedProduct() {
    if (this.isLoadButtonClicked) {
      const dialogRef = this.dialog.open(IraAlertPopupComponent, {
        width: '370px',
        height: '190px',
        disableClose: true,
        data: {
          messages: 'Any changes to product will reload the page. All unsaved',
          messagessub: 'changes will be lost. Do you wish to proceed?',
          messageType: 'clearProduct',
        },
      });

      dialogRef.afterClosed().subscribe((confirm) => {
        if (confirm === true) {
          // User confirmed to clear
          this.selectedProduct = null;
          this.lastConfirmedProduct = null;
          localStorage.removeItem('product');
          localStorage.removeItem('productName');
          //this.isLoadButtonClicked = false;
          //this.loadData.emit(true);

          // ✅ Add this check here
          if (!this.selectedGeography) {
            this.isLoadButtonClicked = false;
          }

          this.clearResultsData.emit();
          this.selectedGeography = null;
          this.lastConfirmedGeography = null;
          localStorage.removeItem('geography');
          localStorage.removeItem('geographyName');
        } else {
          // User cancelled, do nothing
          return;
        }
      });
    } else {
      // No popup, just clear the selection
      this.selectedProduct = null;
      localStorage.removeItem('product');
      localStorage.removeItem('productName');
      this.cdr.detectChanges();
    }
  }

  clearSelectedGeography() {
    if (this.isLoadButtonClicked) {
      const dialogRef = this.dialog.open(IraAlertPopupComponent, {
        width: '370px',
        height: '190px',
        disableClose: true,
        data: {
          messages:
            'Any changes to geography will reload the page. All unsaved',
          messagessub: 'changes will be lost. Do you wish to proceed?',
          messageType: 'clearProduct',
        },
      });

      dialogRef.afterClosed().subscribe((confirm) => {
        if (confirm === true) {
          // User confirmed to clear
          this.selectedGeography = null;
          this.lastConfirmedProduct = null;
          localStorage.removeItem('geography');
          localStorage.removeItem('geographyName');
          //this.isLoadButtonClicked = false;

          // ✅ Add this check here
          if (!this.selectedProduct) {
            this.isLoadButtonClicked = false;
          }

          this.loadData.emit(true);

          //this.clearResultsData.emit();
        } else {
          // User cancelled, do nothing
          return;
        }
      });
    } else {
      // No popup, just clear the selection
      this.selectedGeography = null;
      localStorage.removeItem('geography');
      localStorage.removeItem('geographyName');
      this.cdr.detectChanges();
    }
  }

  isFreshSelection(): boolean {
    return !this.lastConfirmedProduct && !this.lastConfirmedGeography;
  }
}
